/**
 * Sentinel-paginering (#934).
 *
 * `delivery.dashboard_table_orders` henter `p_limit + 1` rader. Får vi den
 * ekstra raden tilbake, finnes det en side til. Det er hele mekanismen —
 * ingen `COUNT(*)` over hele treffmengden, altså ingen kostnad som vokser
 * med ordremengden. Sentinel-raden skal aldri vises; den er kun et signal.
 */
export interface Page<T> {
  rows: T[]
  hasNextPage: boolean
}

export function splitPage<T>(rows: T[], pageSize: number): Page<T> {
  const hasNextPage = rows.length > pageSize
  return {
    rows: hasNextPage ? rows.slice(0, pageSize) : rows,
    hasNextPage,
  }
}
